// extracted by mini-css-extract-plugin
export default {"container":"MCSelector_container__+gaFU","option":"MCSelector_option__lEzOh","selected":"MCSelector_selected__CEpaX","answer":"MCSelector_answer__yCVzy"};